import React, { useState } from 'react'
import { ConfigType } from '../Main'
import { Button } from '../components/Button'
import { ReactComponent as CheckMark } from '../assets/checkmark.svg'
import './form.scss'
import { isValidEmail } from '../util/isValidEmail'
import { ENDPOINTS } from '../service/ENDPOINTS'
import { post } from '../service/API'
import Dialog from 'rc-dialog/es/Dialog'
import './modal.scss'
import { PROJECT_REF } from '../constants'

type Props = {
  data: ConfigType
  navigate: (value: number) => void
  gotoPage: number
}

const errorColor = '#ff622f'

export const RegistrationPage = ({ data, navigate, gotoPage }: Props) => {
  //  const [isLoading, setIsLoading] = useState(true)

  const goToPage = (form) => {
    navigate(gotoPage)

    /*   post(p, formData)
      .then((result) => {
        console.log('RegistrationPage > result = ', result)
        navigate(gotoPage)
        return result
      })
      .catch((error) => {
        console.log('RegistrationPage > error = ', error)
        alert(error)
      })*/
  }

  return (
    <div className="row h-100 d-flex flex-column justify-content-between justify-content-md-start  ">
      <div className="col-12"></div>

      <div className="col-12 d-flex justify-content-center">
        <div className="">
          <h2 className="text-center">{data.registration.headline}</h2>
          <p className="text-center px-4  p-small">{data.registration.description}</p>
          <InputField label="Navn" data={data} goToPage={goToPage}></InputField>
        </div>
      </div>

      <div className="col-12 d-flex justify-content-center mt-3 pb-5"></div>
    </div>
  )
}

type FormType = {
  name: string
  lastname: string
  email: string
  terms: boolean
  privacy: boolean
  dropdown: null | string
}

type FormErrorType = {
  name: boolean
  lastname: boolean
  email: boolean
  terms: boolean
  privacy: boolean
  dropdown: boolean
}

const filedShadow = '0px 0px 0px 1px rgba(255, 255, 255, .7)'
const fontSize = '1rem'

const InputField = ({ label, data, goToPage }) => {
  // toggle the modal
  const [showModal, setShowModal] = useState<boolean>(false)
  const [dropDownSeleted, setDropDownSeleted] = useState<any>('')

  const registration = data.registration

  const [state, setState] = useState<FormType>({
    name: '',
    lastname: '',
    email: '',
    privacy: false,
    terms: false,
    dropdown: null,
  })
  const [error, setErrors] = useState<FormErrorType>({
    name: false,
    lastname: false,
    email: false,
    terms: false,
    privacy: false, // not required
    dropdown: false, // not required
  })
  const onChange = (e) => {
    const key = e.target.name

    if (key && error[key] === true) {
      setErrors({ ...error, [key]: false })
    }

    setState({ ...state, [e.target.name]: e.target.value })
  }

  const validateForm = () => {
    const errorCopy = { ...error }
    const validEmail = isValidEmail(state.email)

    errorCopy.email = !validEmail

    errorCopy.name = state.name.length < 2
    errorCopy.lastname = state.lastname.length < 2

    errorCopy.terms = !state.terms
    errorCopy.dropdown = !state.dropdown
    errorCopy.privacy = !state.privacy

    const errorArr = Object.keys(errorCopy).filter((key) => {
      return errorCopy[key]
    })

    setErrors(errorCopy)
    return errorArr.length !== 0
  }

  const submit = () => {
    const hasErrors = validateForm()

    if (hasErrors) {
      return
    }

    const obj = { ...state, campaignId: PROJECT_REF }
    console.log('RegistrationPage > state = ', obj)
    post(ENDPOINTS.USER.POST, obj)
      .then((result) => {
        console.log('RegistrationPage > result = ', result)

        goToPage(state)
        return result
      })
      .catch((error) => {
        console.log('RegistrationPage > error = ', error)
        alert('Error')
        //return Promise.reject(error)
      })
  }

  const closeDialog = () => {
    setShowModal(false)
  }

  const onDropdownSelect = (value) => {
    setErrors({ ...error, dropdown: false })
    console.log('RegistrationPage > value = ', value)
    setDropDownSeleted(value)
    setState({ ...state, dropdown: value })
    console.log('RegistrationPage > value = ', value)
  }

  const htmlPart = '<p>' + data?.registration?.terms + '</p>'

  return (
    <>
      <Dialog visible={showModal} animation="zoom" maskAnimation="fade" onClose={closeDialog} title="">
        <div className="container-fluid mb-4 ">
          <div className="row" style={{}}>
            <div className="col-12">
              <h4 className="mt-4 mb-4">{data?.registration?.termsHeadline}</h4>

              <div
                className="p-small"
                style={{ whiteSpace: 'pre-line' }}
                dangerouslySetInnerHTML={{ __html: htmlPart }}
              />
            </div>
          </div>
        </div>
      </Dialog>

      <div className="row my-5 px-5">
        <div className="col-12 col-lg-8 mx-auto registration w-100">
          <div className="w-100">
            <input
              className="py-2 px-2 w-100 text-white form-control rounded-2 "
              style={{
                background: 'rgba(255,255,255,.3)',
                fontSize: fontSize,
                boxShadow: error.name ? 'none' : filedShadow,
                outline: 'none',
                border: error.name ? `2px solid ${errorColor}` : 'none',
              }}
              placeholder={data.registration.formFirstName}
              type="text"
              name="name"
              value={state.name}
              onChange={onChange}
            />
            <ErrorMsg key="name" visible={error.name} msg={registration.errorFormFirstName} />
          </div>
          <div className="">
            <input
              className="py-2 px-2 w-100 text-white form-control rounded-2 mt-3 "
              style={{
                background: 'rgba(255,255,255,.3)',
                fontSize: fontSize,
                boxShadow: error.lastname ? 'none' : filedShadow,
                outline: 'none',
                border: error.lastname ? `2px solid ${errorColor}` : 'none',
              }}
              placeholder={data.registration.formLastName}
              type="text"
              name="lastname"
              value={state.lastname}
              onChange={onChange}
            />
            <ErrorMsg key="lastname" visible={error.lastname} msg={registration.errorFormLastName} />
          </div>
          <div className="">
            <input
              className="py-2 px-2 w-100 text-white form-control rounded-2 mt-3 "
              style={{
                background: 'rgba(255,255,255,.3)',
                fontSize: fontSize,
                boxShadow: error.email ? 'none' : filedShadow,
                outline: 'none',
                border: error.email ? `2px solid ${errorColor}` : 'none',
              }}
              placeholder={data.registration.formEmail}
              type="text"
              name="email"
              value={state.email}
              onChange={onChange}
            />

            <ErrorMsg key="email" visible={error.email} msg={registration.errorFormEmail} />
          </div>
          <div className="mt-3">
            <Dropdown
              data={data}
              error={error.dropdown}
              selected={dropDownSeleted}
              onSelect={onDropdownSelect}
              errorMsg={registration.errorDropDown}
            ></Dropdown>
          </div>
          <div className="mt-6">
            <Checkbox
              label={data.registration.checkBoxOne}
              setShowModal={setShowModal}
              urlLink=""
              formKey="terms"
              setForm={setState}
              formObj={state}
              error={error.terms}
              errorMsg={registration.errorCheckbox}
            ></Checkbox>
          </div>
          <div className="mt-3">
            <Checkbox
              label={data.registration.checkBoxTwo}
              urlLink={data.registration.checkBoxTwoLink}
              setShowModal=""
              formKey="privacy"
              setForm={setState}
              formObj={state}
              error={error.privacy}
              errorMsg={registration.errorCheckboxTwo}
            ></Checkbox>
          </div>

          <div className="d-flex justify-content-center mt-5">
            <Button onClick={submit} style={{ width: '100%' }} label={data.registration.submitBtn}></Button>
          </div>
        </div>
      </div>
    </>
  )
}

const ErrorMsg = ({ visible, msg }) => {
  return (
    <>
      {visible ? (
        <p className="p-small mt-2" style={{ color: errorColor }}>
          {msg}
        </p>
      ) : null}
    </>
  )
}

const Dropdown = ({ data, selected, onSelect, error, errorMsg }) => {
  const optionsTitle = data.registration?.dropDownTitle || 'missing'
  const optionsOne = data.registration?.dropDownOptionOne || 'missing'
  const optionsTwo = data.registration?.dropDownOptionTwo || 'missing'
  const optionsThree = data.registration?.dropDownOptionThree || 'missing'
  const optionsFour = data.registration?.dropDownOptionFour || 'missing'
  const optionsFive = data.registration?.dropDownOptionFive || 'missing'
  const optionsSix = data.registration?.dropDownOptionSix || 'missing'

  const handleSelect = (e) => {
    const isPlaceHolder = e.target.value === optionsTitle ? true : false
    if (isPlaceHolder) {
      return
    }
    const value = e.target.value || ''

    onSelect(value.trim())
  }

  const options = [optionsTitle, optionsOne, optionsTwo, optionsThree, optionsFour, optionsFive, optionsSix]
  const num = options.filter((item) => (item === 'missing' ? false : true))
  //const error = { email: '' }
  return (
    <>
      <div
        className="py-2 px-2 w-100 text-white form-control rounded-2  "
        style={{
          background: 'rgba(255,255,255,.3)',
          fontSize: fontSize,
          boxShadow: error ? 'none' : filedShadow,
          outline: 'none',
          border: error ? `2px solid ${errorColor}` : 'none',
        }}
      >
        <select
          name="select"
          placeholder="asdasd"
          className=" w-100 text-white form-control rounded-2  "
          onChange={handleSelect}
          value={selected}
          style={{
            background: 'transparent',
            fontSize: fontSize,
            outline: 'none',
            border: error.email ? `2px solid ${errorColor}` : 'none',
          }}
        >
          {num.map((n, index) => {
            return (
              <option key={index} value={n} className="text-black">
                {n}
              </option>
            )
          })}
        </select>
      </div>
      <div className="">
        <ErrorMsg visible={error} msg={errorMsg} />
      </div>
    </>
  )
}

/**
 *
 * CHECK BOXES
 *
 */

const Checkbox = ({ label = 'missing', setForm, formKey, formObj, error, urlLink, setShowModal, errorMsg = '' }) => {
  const clickker = () => {
    setForm({ ...formObj, [formKey]: !formObj[formKey] })
  }

  const selected = formObj[formKey] as boolean

  const labelLinkFirst: number = label.indexOf('{{')
  const labelLinkSecond: number = label.indexOf('}}')

  const first = labelLinkFirst > -1 ? label.slice(0, labelLinkFirst) : '' //label.split(labelLinkFirst + 2)
  const second = labelLinkSecond > -1 ? label.slice(labelLinkSecond + 2) : ''
  const linkText = first ? label.slice(labelLinkFirst + 2, labelLinkSecond) : ''

  return (
    <>
      <div className="d-flex pointer">
        <div className="position-relative">
          {selected ? (
            <CheckMark
              className="noselect position-absolute mt-1 "
              style={{ marginLeft: 5, top: 0, left: 0, pointerEvents: 'none' }}
            ></CheckMark>
          ) : null}

          <div
            onClick={clickker}
            className="rounded-2"
            style={{
              background: 'rgba(255,255,255,.3)',
              boxShadow: error ? 'none' : '0px 0px 0px 1px rgba(255, 255, 255, .9)',
              outline: 'none',
              border: error ? `2px solid ${errorColor}` : 'none',
              width: 24,
              height: 24,
            }}
          ></div>
        </div>

        {urlLink ? (
          <p className="ms-3 p-small">
            <span>{first}</span>
            <span className="fw-bold">
              <a
                className="text-decoration-none text-decoration-underline text-white"
                href={urlLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkText}
              </a>
            </span>
            <span>{second}</span>
          </p>
        ) : (
          <p
            className="ms-3 p-small"
            onClick={() => {
              setShowModal(true)
            }}
          >
            <span>{first}</span>
            <span className="fw-bold text-decoration-underline">{linkText}</span>
            <span>{second}</span>
          </p>
        )}
      </div>

      <div className="ms-6">
        <ErrorMsg visible={error} msg={errorMsg} />
      </div>
    </>
  )
}
